<template>
	<button :disabled="loading" :class="[
		'btn btn-'+theme, 
		icon && !$slots.default ? 'btn-icon': ''
	]" v-bind="$attrs" @click="$emit('click', $event)">

		<div v-if="loading" :class="[
			'spinner-border spinner-border-sm',
			$slots.default ? 'mr-2' : ''
		]" role="status">
			<span class="sr-only">Loading...</span>
		</div>

		<i v-else-if="icon" :class="[
			'fe fe-'+icon,
			$slots.default ? 'small mr-2' : ''
		]"></i>

		<slot />
	</button>
</template>

<script>
	export default {
		props: {
			loading: [Number, Boolean],
			icon: String,
			theme: {
				type: String,
				default: 'primary'
			}
		},
	}
</script>